import React, { useEffect, useState } from 'react'
import { Card, CardImg, BodyCard, ProductName, PriceSecond, RegularPrice, Price } from '../../theme/theme'
import Slider from "react-slick";
import { RootState } from '../../redux/reducers/index'
import { ContainerCard } from '../../theme/theme'
import { StylePrev, StyleNext, BtnLoadMore, CardLoadMore, ParagraphLoadMore } from './style'
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux'
import CornerRibbon from "react-corner-ribbon";
import AddFrom from '../AddFrom';
import useView from '../../hooks/useView';
import CardSkeleton from '../CardSkeleton';
import CurrencyFormat from '../../utils/currencyFormat'
import {calculatePriceWithTax, returnProduct} from '../../utils/formatData'
import { language } from '../../utils/language';

var settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: (<StyleNext />),
    prevArrow: (<StylePrev />),
    responsive: [
        {
            breakpoint: 1640,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: false,
                dots: false
            }
        },
        {
            breakpoint: 1350,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1.5,
                dots: false
            }
        }
    ]
};

const CardCategory = ({ categoryId, outstanding, products }: any) => {
    const { width, display } = useView()
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
    const [listproducts, setListProducts] = useState([]);
    const history = useHistory();

    let isDesktopOrLaptop: boolean = width > 1200;

    const checkIndex = isDesktopOrLaptop ? 5 : 4;

    const handleHomeRedirect = () => {
        history.push(`/`)
    }

    const handleCategoryDetailRedirect = (categoryId2: any, outstanding2: any) => {
        if (outstanding2) {
            history.push(`/vende/${homeState.catalogueUrlName}/detailcategory/0`)
        } else {
            history.push(`/vende/${homeState.catalogueUrlName}/detailcategory/${categoryId2}`)
        }
    }

    const handleProductDetailRedirect = (categoryId2: any, productId: any) => {
        history.push(`/vende/${homeState.catalogueUrlName}/product-info/${categoryId2}/${productId}`)
    }

    useEffect(() => {

        if(products && products.length)
        {
            if (!isDesktopOrLaptop) {
                setListProducts(products.slice(0, 5))
            } else {
                setListProducts(products.slice(0, 6))
            }
        }
    
    }, [isDesktopOrLaptop, products]) 

    return (
        <div style={{ marginTop: 20 }}>
            {
                listproducts.length === 0 ?
                    <>
                        {display === "desktop" ?
                            <CardSkeleton cards={4} width={200} height={200} />
                            :
                            <CardSkeleton cards={3} />
                        }
                    </>
                    :
                    <Slider {...settings}>
                        {
                            listproducts.filter((p: any) => p.available > 0).map((field: any, index: any) => (
                                <>
                                    {index === checkIndex ?
                                        <ContainerCard lastImage={true} key={'Cards' + index.toString()}>
                                            <Card >
                                                <BodyCard>
                                                    <CardLoadMore>
                                                        <ParagraphLoadMore>{language[homeState.default_language]["continueCategory"]}</ParagraphLoadMore>
                                                        <BtnLoadMore color={homeState.color} onClick={() => handleCategoryDetailRedirect(field.categories, outstanding)}>{language[homeState.default_language]["more"]}</BtnLoadMore>
                                                    </CardLoadMore>
                                                </BodyCard>
                                            </Card>
                                        </ContainerCard>
                                        :
                                        <ContainerCard lastImage={false} onClick={() => handleProductDetailRedirect(field.categories[0], field.id)} key={'Cards' + index.toString()}>
                                            <Card discount={returnProduct(field, 'discountRate') >= 1 ? returnProduct(field, 'discountRate') : 0} secondImage={field.img[1] ? field.img[1] : field.img[0]} bgColor="#fff">
                                                <div className="boxShadow-node" style={{ position: "relative" }}>
                                                    {returnProduct(field, 'discountRate') > 0 && <CornerRibbon backgroundColor="#ff0000" fontColor="#f0f0f0" containerStyle={{}}>
                                                        <AddFrom product={field} field={"discountRate"} fontSize={display === "desktop" ? ".6rem" : ".5rem"} fontWeight="600" br={true} />
                                                        <span style={{fontFamily: 'Roboto', fontWeight: 700, fontSize: '1.3em'}}>
                                                            {' '+returnProduct(field, 'discountRate')}%off
                                                        </span>
                                                    </CornerRibbon> }
                                                    <>
                                                        <a onClick={handleHomeRedirect}>
                                                            <CardImg src={field.img[0]} />
                                                        </a>
                                                        <BodyCard>
                                                            <ProductName text={field.title} />
                                                            {returnProduct(field, 'discountRate') > 0 ?                                                                        
                                                                <>
                                                                    <RegularPrice>
                                                                        <AddFrom product={field} fontSize="1rem"/> <CurrencyFormat amount={returnProduct(field, 'netAmount') !== 0 ? calculatePriceWithTax(returnProduct(field)) : returnProduct(field, 'amount')}/>
                                                                    </RegularPrice>
                                                                    <Price>
                                                                        <AddFrom product={field} /> <CurrencyFormat amount={returnProduct(field, 'amount')}/>
                                                                    </Price>
                                                                </>
                                                                :
                                                                <PriceSecond>
                                                                    <AddFrom product={field} /> <CurrencyFormat amount={returnProduct(field, 'amount')}/>
                                                                </PriceSecond>
                                                            }
                                                        </BodyCard>
                                                    </>
                                                </div>
                                            </Card>
                                        </ContainerCard>
                                    }
                                </>
                            ))
                        }
                    </Slider>
            }
        </div>)
}

export default CardCategory
